import { makeCraftClient } from '@cloak-app/craft/factories'
import Vue from 'vue'

# Make the Craft adapter ouside of Nuxt
export default $craft = makeCraftClient
	site: process.env.CMS_SITE
	endpoint: process.env.CMS_ENDPOINT

# Inject it globally
Vue.prototype.$craft = $craft
